import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import ColumnDropdownSelector from 'data-frames/column-selector/ColumnDropdownSelector';
import {DataFrameSpec} from 'data-frames/DataFrameTypes';

export interface DataFrameColumnRelationship {
  leftColumn: string | null;
  rightColumn: string | null;
}

export interface DataFrameColumnRelationshipSelectorProps {
  leftDataFrame: DataFrameSpec;
  rightDataFrame: DataFrameSpec;
  relationship: DataFrameColumnRelationship;
  onSelectRelationship: (newRelationship: DataFrameColumnRelationship) => void;
  readOnly?: boolean;
}

export default function DataFrameColumnRelationshipSelector(
  props: DataFrameColumnRelationshipSelectorProps
): JSX.Element {
  return (
    <div className={css(styles.wrapper)}>
      <div className={css(styles.selector, styles.selectorLeft)}>
        <ColumnDropdownSelector
          dataFrameSpec={props.leftDataFrame}
          selectedColumnSystemName={props.relationship.leftColumn}
          onChange={(leftColumn) => {
            props.onSelectRelationship({...props.relationship, leftColumn});
          }}
          disabled={props.readOnly}
          dataTestAttrs={{component: 'DataFrameColumnRelationshipSelector', element: 'leftColumnSelector'}}
        />
      </div>
      <div className={css(styles.selector)}>
        <ColumnDropdownSelector
          dataFrameSpec={props.rightDataFrame}
          selectedColumnSystemName={props.relationship.rightColumn}
          onChange={(rightColumn) => {
            props.onSelectRelationship({...props.relationship, rightColumn});
          }}
          disabled={props.readOnly}
          dataTestAttrs={{component: 'DataFrameColumnRelationshipSelector', element: 'rightColumnSelector'}}
        />
      </div>
    </div>
  );
}

export const styles = StyleSheet.create({
  selector: {
    width: 'calc(50% - 12px)',
  },
  selectorLeft: {
    marginRight: 24,
  },
  wrapper: {
    display: 'inline-flex',
    width: '100%',
  },
});
